import styles from '../../assets/styles/LandingPage/MimaIsSafe.module.scss';
import React from 'react';

import SecureImg from '../../assets/img/Mima-Secure 1.png';

const MimaIsSafe = () => {
	return (
		<section className={styles.safe}>
			<img
				src={SecureImg}
				className={styles.safe__img}
				alt="MIma is safe and Secure"
			/>
			<div className={styles.safe__text}>
				<div className={styles.safe__text_title}>
					Your Business funds 100% <br />
					Safe and Secured
				</div>
				<div className={styles.safe__text_body}>
					We make use of bank-grade security with all your monies fully insured
					by NDIC; also making use of 256bits SSL security encryption, making
					sure that your information is completely protected from fraud.
				</div>
			</div>
			safe
		</section>
	);
};

export default MimaIsSafe;
